import React, {useState, useEffect, Suspense} from 'react';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import { UUIDUtil } from '@aperza/util';
import useReactiveMessage from '../../hook/UseReactiveMessage';
import CatalogDownloadModal from './CatalogDownloadModal';

const GET_VIEWER = gql`
    query getViewer($leadType: String!)
    {
        viewer {
            ...CatalogDownloadModal_viewer
        }
    }
    ${CatalogDownloadModal.fragments.viewer}
`;

const CatalogDownloadModalLoader = (props) => {

  let [show, setShow] = useState(false);
  let [errorId, setErrorId] = useState(false);
  let [viewer, setViewer] = useState();
  const [catalog, setCatalog] = useState({
    requestId: undefined,
    companyId: undefined,
    catalogId: undefined,
  });

  let subscription;
  const {getMessage} = useReactiveMessage('CATALOG_DOWNLOAD');

  const onCompleted = (data) => {
    setViewer(data.viewer);
  };

  const onQueryError = () => {
    setErrorId('errorId');
  };

  const refetchForModal = async () => {
    try {
      setErrorId();
      setShow(true);
      let response = await refetch();
      setViewer(response.data.viewer);
    } catch (e) {
      setErrorId('errorId');
    }
  };

  let {loading, error, networkStatus, data, refetch} = useQuery(GET_VIEWER, {
    variables: {
      leadType: 'DOWNLOAD_CATALOG',
    },
    onCompleted:onCompleted,
    onError: onQueryError,
  });

  useEffect(() => {
    if (!loading && error && catalog.requestId) {
      refetchForModal();
    } else if (!error && catalog.requestId) {
      setShow(true);
    }
  }, [catalog]);

  useEffect(() => {
    subscription = getMessage().subscribe(message => {
      if (message && message.companyId && message.catalogId) {
        setCatalog({
          requestId: UUIDUtil.uuid(),
          companyContractDisplayId: message.companyContractDisplayId,
          companyId: message.companyId,
          catalogId: message.catalogId,
          catalogPreview: message.catalogPreview,
          documentId: message.documentId,
        });

      }
    });

    //TODO should disable the download button on search-web.
    //Only enable the button after the listener has been registered.
    let elements = document.getElementsByClassName('catalogDownloadLink');
    elements.forEach(el => {
      el.addEventListener('click', (event) => {
        let source = event.currentTarget;
        if (source && source.dataset.company_id && source.dataset.catalog_id) {
          event.preventDefault();
          setCatalog({
            requestId: UUIDUtil.uuid(),
            companyContractDisplayId: parseInt(source.dataset.company_contract_display_id),
            companyId: parseInt(source.dataset.company_id),
            catalogId: parseInt(source.dataset.catalog_id),
            documentId: source.dataset.document_id,
          });
        }
      })
    })
  }, []);

  const onCloseModal = () => {
    setShow(false);
  };

  useEffect(() => {
    if (window.addEventListener) {
      window.addEventListener("message", onMessage, false);
    } else if (window.attachEvent) {
      window.attachEvent("onmessage", onMessage, false);
    }
    window.aperza.aw.catalogDownloadModal = new Date().getTime();
  }, []);

  const onMessage = (event) => {
    if (event) {
      if (event.origin.includes('//id.')) {
        try {
          let data = JSON.parse(event.data);
          if (data.action === 'closeDialog' || data.action === 'close') {
            // if (props.onLogin) {
            //   props.onLogin();
            // }
            refetchForModal();
          }
        } catch (e) {
        }
        ;
      }
    }
  };

  return (
    <Suspense fallback={<div style={{display: 'none'}}></div>}>
      <CatalogDownloadModal viewer={viewer}
                            show={show}
                            errorId={errorId}
                            onClose={onCloseModal}
                            requestId={catalog.requestId}
                            companyContractDisplayId={catalog.companyContractDisplayId}
                            catalogId={catalog.catalogId}
                            companyId={catalog.companyId}
                            catalogPreview={catalog.catalogPreview}
                            documentId={catalog.documentId} />
    </Suspense>
  );

};

export default CatalogDownloadModalLoader;

